import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { Header, Footer } from './components/layout';
import { Home } from './components/home';
import { Dashboard } from './components/dashboard/Dashboard';
import { AppPage } from './components/app';
import { Watch } from './components/watch';
import TermsOfService from './components/legal/TermsOfService';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import { MyAccount } from './components/account';
import LoginPage from './components/auth/LoginPage';
import SignUpPage from './components/auth/SignUpPage';
import SsoCallbackPage from './components/auth/SsoCallbackPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Box
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/app" element={<AppPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/groups" element={<Dashboard />} />
          <Route path="/watch/:groupId" element={<Watch />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/my-account" element={<MyAccount />} />
          <Route path="/login/*" element={<LoginPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route path="/sso-callback" element={<SsoCallbackPage />} />
        </Routes>

        <Footer />
      </Box>
    </BrowserRouter>
  );
}

export default App;
